import { render, staticRenderFns } from "./SaleEditProperties.vue?vue&type=template&id=5eb52997&scoped=true"
import script from "./SaleEditProperties.vue?vue&type=script&lang=ts"
export * from "./SaleEditProperties.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditProperties.vue?vue&type=style&index=0&id=5eb52997&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb52997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb52997')) {
      api.createRecord('5eb52997', component.options)
    } else {
      api.reload('5eb52997', component.options)
    }
    module.hot.accept("./SaleEditProperties.vue?vue&type=template&id=5eb52997&scoped=true", function () {
      api.rerender('5eb52997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditProperties.vue"
export default component.exports